import React, { useEffect, useState, lazy } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { PageHero } from '../components/PageHero';
import { MapPin, Mail, User, Building, Info, Navigation, X, ZoomIn } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const contacts = [{
  role: 'Президент федерації',
  name: 'Ясинська Ганна',
  email: 'head@umcf.org.ua',
  icon: <User className="h-5 w-5 text-primary" data-id="element-565" />
}, {
  role: 'Відповідальний секретар',
  name: 'Марина Гнідан',
  email: 'office@umcf.org.ua',
  icon: <Building className="h-5 w-5 text-primary" data-id="element-566" />
}, {
  role: 'Загальні питання',
  name: null,
  email: 'info@umcf.org.ua',
  icon: <Mail className="h-5 w-5 text-primary" data-id="element-567" />
}];
export function ContactsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [lightboxSrc, setLightboxSrc] = useState<string | null>(null);
  return <div className="min-h-screen bg-gray-50" data-id="element-568">
      <Header data-id="element-569" />

      {/* Lightbox */}
      <AnimatePresence data-id="element-570">
        {lightboxSrc && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-[100] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 cursor-pointer" onClick={() => setLightboxSrc(null)} data-id="element-571">
            <button onClick={() => setLightboxSrc(null)} className="absolute top-4 right-4 text-white/70 hover:text-white transition-colors z-10" data-id="element-572">
              <X className="h-7 w-7" data-id="element-573" />
            </button>
            <motion.img initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} transition={{
          duration: 0.2
        }} src={lightboxSrc} alt="" className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-574" />
          </motion.div>}
      </AnimatePresence>

      <main className="pt-20" data-id="element-575">
        <PageHero label="Зв'яжіться з нами" title="Контакти" subtitle="Зв'яжіться з Федерацією Альпінізму і Скелелазіння України" data-id="element-576" />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16" data-id="element-577">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-578">
            {/* Left: Contact Info */}
            <div className="space-y-8" data-id="element-579">
              {/* Address */}
              <motion.div initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5
            }} className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-580">
                <div className="flex items-start gap-4" data-id="element-581">
                  <div className="p-2.5 bg-primary/5 rounded-lg border border-primary/10 flex-shrink-0" data-id="element-582">
                    <MapPin className="h-5 w-5 text-primary" data-id="element-583" />
                  </div>
                  <div data-id="element-584">
                    <h2 className="text-lg font-bold text-primary mb-2" data-id="element-585">
                      Наша адреса
                    </h2>
                    <p className="text-gray-700 text-sm font-medium" data-id="element-586">
                      Україна, Київ, вул. Є.Чавдар, 10
                    </p>
                    <p className="text-gray-500 text-sm mt-1" data-id="element-587">м. Осокорки</p>
                  </div>
                </div>

                <div className="mt-4 ml-[52px] flex items-start gap-2 bg-gray-50 rounded-md p-3 border border-gray-100" data-id="element-588">
                  <Navigation className="h-4 w-4 text-gray-400 mt-0.5 flex-shrink-0" data-id="element-589" />
                  <p className="text-gray-500 text-xs leading-relaxed" data-id="element-590">
                    Орієнтир — шиномонтаж. За ним знаходиться триповерховий
                    будинок. Офіс на другому поверсі, перші двері ліворуч.
                  </p>
                </div>
              </motion.div>

              {/* Contact Persons */}
              <div className="space-y-4" data-id="element-591">
                {contacts.map((contact, index) => <motion.div key={contact.email} initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                delay: 0.1 + index * 0.1,
                duration: 0.5
              }} className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-592">
                    <div className="flex items-start gap-4" data-id="element-593">
                      <div className="p-2.5 bg-primary/5 rounded-lg border border-primary/10 flex-shrink-0" data-id="element-594">
                        {contact.icon}
                      </div>
                      <div data-id="element-595">
                        <h3 className="text-sm font-bold text-primary" data-id="element-596">
                          {contact.role}
                        </h3>
                        {contact.name && <p className="text-gray-700 text-sm mt-1" data-id="element-597">
                            {contact.name}
                          </p>}
                        <a href={`mailto:${contact.email}`} className="text-sm text-primary/80 hover:text-primary hover:underline mt-1 inline-block transition-colors" data-id="element-598">
                          {contact.email}
                        </a>
                      </div>
                    </div>
                  </motion.div>)}
              </div>

              {/* Additional Info */}
              <motion.div initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.5,
              duration: 0.5
            }} className="flex items-start gap-3 bg-primary/5 rounded-lg p-4 border border-primary/10" data-id="element-599">
                <Info className="h-4 w-4 text-primary/60 mt-0.5 flex-shrink-0" data-id="element-600" />
                <p className="text-xs text-gray-600 leading-relaxed" data-id="element-601">
                  Для офіційних запитів та листування використовуйте електронну
                  адресу{' '}
                  <a href="mailto:office@umcf.org.ua" className="text-primary font-medium hover:underline" data-id="element-602">
                    office@umcf.org.ua
                  </a>
                  . Час роботи офісу: Пн–Пт, 10:00–18:00.
                </p>
              </motion.div>
            </div>

            {/* Right: Map + How to find us */}
            <div className="space-y-8" data-id="element-603">
              <motion.div initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.2,
              duration: 0.5
            }} data-id="element-604">
                <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-605">
                  <iframe title="Офіс ФАіСУ" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2542.8!2d30.6158!3d50.3942!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40d4c5e2b8e3c8e7%3A0x1234567890abcdef!2z0LLRg9C7LiDQhS7Qq9Cw0LLQtNCw0YAsIDEwLCDQmtC40ZfQsg!5e0!3m2!1suk!2sua!4v1700000000000" width="100%" height="300" style={{
                  border: 0
                }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" className="w-full" data-id="element-606" />
                </div>
              </motion.div>

              {/* Orientation Photos */}
              <motion.div initial={{
              opacity: 0,
              y: 16
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.3
            }} data-id="element-607">
                <h2 className="text-lg font-bold text-primary mb-4" data-id="element-608">
                  Як нас знайти
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-609">
                  <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-610">
                    <div className="relative group cursor-pointer" onClick={() => setLightboxSrc('https://cdn.magicpatterns.com/uploads/vCq6wJ4CU8WMBzLVVpXg8x/fais-contacts-1.jpg')} data-id="element-611">
                      <img src="https://cdn.magicpatterns.com/uploads/vCq6wJ4CU8WMBzLVVpXg8x/fais-contacts-1.jpg" alt="Маршрут від м. Осокорки до офісу ФАіСУ" className="w-full h-48 object-cover transition-transform duration-300 group-hover:scale-105" data-id="element-612" />
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center" data-id="element-613">
                        <ZoomIn className="h-8 w-8 text-white opacity-0 group-hover:opacity-100 transition-opacity drop-shadow-lg" data-id="element-614" />
                      </div>
                    </div>
                    <div className="p-3" data-id="element-615">
                      <p className="text-sm font-medium text-gray-700" data-id="element-616">
                        Маршрут від м. Осокорки
                      </p>
                      <p className="text-xs text-gray-500 mt-1" data-id="element-617">
                        Рухайтесь від метро Осокорки вздовж вул. Є. Чавдар.
                        Орієнтир — шиномонтаж.
                      </p>
                    </div>
                  </div>
                  <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-618">
                    <div className="relative group cursor-pointer" onClick={() => setLightboxSrc('https://cdn.magicpatterns.com/uploads/5DDmANggzRYJYA9oYeBpaq/fais-contacts-2.jpg')} data-id="element-619">
                      <img src="https://cdn.magicpatterns.com/uploads/5DDmANggzRYJYA9oYeBpaq/fais-contacts-2.jpg" alt="Вхід до офісу ФАіСУ" className="w-full h-48 object-cover transition-transform duration-300 group-hover:scale-105" data-id="element-620" />
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center" data-id="element-621">
                        <ZoomIn className="h-8 w-8 text-white opacity-0 group-hover:opacity-100 transition-opacity drop-shadow-lg" data-id="element-622" />
                      </div>
                    </div>
                    <div className="p-3" data-id="element-623">
                      <p className="text-sm font-medium text-gray-700" data-id="element-624">
                        Вхід до офісу
                      </p>
                      <p className="text-xs text-gray-500 mt-1" data-id="element-625">
                        Вивіска «Федерація Альпінізму і Скелелазіння України» на
                        дверях. Офіс на 2-му поверсі, перші двері ліворуч.
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-626" />
    </div>;
}